import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import AuthSlider from '../AuthenticationInner/authCarousel';

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { signIn } from '@aws-amplify/auth';
import { getCurrentUser, fetchAuthSession, resendSignUpCode } from 'aws-amplify/auth';
import { profiledata } from '../../slices/thunks';

// actions
import { loginUser, socialLogin, resetLoginFlag } from "../../slices/thunks";

import logoLight from "../../assets/images/logo-light.png";
import { createSelector } from 'reselect';

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
//import images

const Login = (props) => {
    useEffect(() => {
        const guser = (async () => {
            const token = localStorage.getItem('authUser')
            if (token) {
                props.router.navigate("/dam");
            }
        });

        guser();

    })

    const [userLogin, setUserLogin] = useState([]);
    const [passwordShow, setPasswordShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const dispatch = useDispatch();
    const selectLayoutState = (state) => state.Account;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (layout) => ({
            user: layout.user,
            errorMsg: layout.errorMsg,
            loading: layout.loading,
            error: layout.error,
        })
    );
    // Inside your component
    const {
        user,
        errorMsg
    } = useSelector(selectLayoutProperties);




    useEffect(() => {
        if (user && user) {
            const updatedUserData = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? user.multiFactor.user.email : user.user.email;
            const updatedUserPassword = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? "" : user.user.confirm_password;
            setUserLogin({
                email: updatedUserData,
                password: updatedUserPassword
            });
        }
    }, [user]);


    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: userLogin.email || " " || '',
            password: userLogin.password || "" || '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            try {

                const { nextStep } = await signIn({
                    username: values.email,
                    password: values.password
                });
                // console.log(nextStep);

                const { signInStep } = nextStep;
                if (signInStep === "DONE") {
                    // Handle other login scenarios


                    const session = await fetchAuthSession();
                    localStorage.setItem("token", session.tokens.idToken)
                    localStorage.setItem("AccessToken", session.tokens.accessToken);
                    localStorage.setItem("IdToken", session.tokens.idToken);
                    toast.success("Login successful!");
                    props.router.navigate("/");
                    // console.log(session);

                    const { username, userId, signInDetails } = await getCurrentUser();
                    // console.log(signInDetails);
                    dispatch(profiledata(userId));

                    const loginUser = {
                        username: username,
                        userId: userId
                    }
                    localStorage.setItem("authUser", JSON.stringify(loginUser))
                    // Navigate to a different page after successful login

                } else if (signInStep === "CONFIRM_SIGN_UP") {

                    // console.log(validation.values.email);
                    await resendSignUpCode({ username: validation.values.email });
                    toast.warning("Please Confirm Sign up before Sign In");
                    props.router.navigate("/confirm-email", { state: { email: validation.values.email } })
                }
                // Show success toaster

            } catch (error) {
                // console.log("Error logging in", error);
                setError(error.message || "Error logging in");

                // Show error toaster
                toast.error(error.message || "Error logging in");
            }
            setLoading(false);
        }
    });



    //for facebook and google authentication
    const socialResponse = type => {
        signIn(type);
    };


    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => {
                dispatch(resetLoginFlag());
            }, 3000);
        }
    }, [dispatch, errorMsg]);

    document.title = "Media Pulse | Sign In";
    return (
        <React.Fragment>
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>

                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="overflow-hidden">
                                    <Row className="g-0">
                                        <AuthSlider />

                                        <Col lg={6}>
                                            <div className="p-lg-5 p-4">
                                                <div>
                                                    <h5 className="text-primary">Welcome Back !</h5>
                                                    <p className="text-muted">Sign in to continue to Media Pulse.</p>
                                                </div>

                                                <div className="mt-4">
                                                    <form onSubmit={(e) => {
                                                        e.preventDefault();
                                                        validation.handleSubmit();
                                                        return false;
                                                    }}>

                                                        <div className="mb-3">
                                                            <Label htmlFor="email" className="form-label">Email</Label>
                                                            <Input
                                                                name="email"
                                                                className="form-control"
                                                                placeholder="Enter email"
                                                                type="email"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.email || ""}
                                                                invalid={validation.touched.email && validation.errors.email ? true : false}
                                                            />
                                                            {validation.touched.email && validation.errors.email && (
                                                                <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                            )}
                                                        </div>

                                                        <div className="mb-3">
                                                            <div className="float-end">
                                                                <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                                                            </div>
                                                            <Label className="form-label" htmlFor="password-input">Password</Label>
                                                            <div className="position-relative auth-pass-inputgroup mb-3">
                                                                <Input
                                                                    name="password"
                                                                    value={validation.values.password || ""}
                                                                    type={passwordShow ? "text" : "password"}
                                                                    className="form-control pe-5"
                                                                    placeholder="Enter Password"
                                                                    onChange={validation.handleChange}
                                                                    onBlur={validation.handleBlur}
                                                                    invalid={validation.touched.password && validation.errors.password ? true : false}
                                                                />
                                                                {validation.touched.password && validation.errors.password && (
                                                                    <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                                )}
                                                                <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" onClick={() => setPasswordShow(!passwordShow)} id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                                                            </div>
                                                        </div>

                                                        <div className="form-check">
                                                            <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                            <Label className="form-check-label" htmlFor="auth-remember-check">Remember me</Label>
                                                        </div>

                                                        <div className="mt-4">
                                                            <Button color="success" disabled={loading} className="w-100" type="submit">
                                                                {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : "Sign In"}</Button>
                                                        </div>



                                                    </form>
                                                </div>

                                                <div className="mt-5 text-center">
                                                    <p className="mb-0">Don't have an account ? <Link to="/register" className="fw-semibold text-primary text-decoration-underline">
                                                        Signup</Link> </p>
                                                </div>
                                                <div className="mt-4 text-center">
                                                   
                                                        <p className="mb-0">
                                                            <a href="https://www.mediapulse.io/terms" className="text-muted text-decoration" rel="noopener noreferrer">Terms of Service</a>  |  
                                                            <a href="https://www.mediapulse.io/privacy-policy" className="text-muted text-decoration" rel="noopener noreferrer"> Privacy Policy</a>
                                                        </p>
                                                   
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <footer className="footer">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center">
                                    <p className="mb-0">&copy; {new Date().getFullYear()} Whistlemind Technologies LLP. Crafted with <i className="mdi mdi-heart text-danger"></i> </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </footer>

            </div>
        </React.Fragment>
    );
};

export default withRouter(Login);

